import React from "react";

import PaymentInstallment from "components/school_money/payments/PaymentInstallment";

export default class PaymentInstallmentList extends React.Component {
  
  render() {
    const { paymentID, installmentNumberList, showAddRemoveButtons } = this.props;
    return (
      <table className="payment-installments">
        <tbody>
          {
            installmentNumberList.map(installmentNumber => (
              <PaymentInstallment
                key={installmentNumber}
                paymentID={paymentID}
                installmentNumber={installmentNumber}
                showAddRemoveButtons={showAddRemoveButtons}
              />
            ))
          }
        </tbody>
      </table>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/payments/PaymentInstallmentList.js